import { createApiClient } from '@/api/apiClient';
import { API_BASE_URLS } from '@/constants';

const coreApiService = createApiClient({
  baseURL: API_BASE_URLS.BASE_URL,
});

const dataManagementApiService = createApiClient({
  baseURL: API_BASE_URLS.DATA_MANAGEMENT_API_URL,
});

const uiStatusApiService = createApiClient({ baseURL: API_BASE_URLS.DATA_MANAGEMENT_API_URL }, true);

export const apiServices = { coreApiService, dataManagementApiService, uiStatusApiService };
